import {
    EventInteractions,
    useEventCardTrackingContext,
} from '@eventbrite/event-renderer';
import { gettext } from '@eventbrite/i18n';
import React from 'react';

import styles from './PlanMyNightChip.module.scss';

export interface PlanMyNightChipProps {
    eventId: string;
}

const PLANS_PATH = '/plans/';

const SignalAiIcon: React.FC = () => (
    <svg
        className={styles.icon}
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M5.79427 0C5.9823 1.1687 6.41732 3.06055 7.34505 3.98828C8.27275 4.91598 10.1646 5.35037 11.3333 5.53841V5.79427C10.1646 5.9823 8.27278 6.41732 7.34505 7.34505C6.41732 8.27278 5.9823 10.1646 5.79427 11.3333H5.53906C5.35103 10.1646 4.91601 8.27278 3.98828 7.34505C3.06055 6.41732 1.1687 5.9823 0 5.79427V5.53841C1.16871 5.35037 3.06058 4.91598 3.98828 3.98828C4.91601 3.06055 5.35103 1.16871 5.53906 0H5.79427Z"
            fill="currentColor"
        />
        <path
            d="M9.16667 8.33333C9.6269 8.33333 10 8.70643 10 9.16667C10 9.6269 9.6269 10 9.16667 10C8.70643 10 8.33333 9.6269 8.33333 9.16667C8.33333 8.70643 8.70643 8.33333 9.16667 8.33333Z"
            fill="currentColor"
        />
        <path
            d="M2.16667 1.33333C2.6269 1.33333 3 1.70643 3 2.16667C3 2.6269 2.6269 3 2.16667 3C1.70643 3 1.33333 2.6269 1.33333 2.16667C1.33333 1.70643 1.70643 1.33333 2.16667 1.33333Z"
            fill="currentColor"
        />
    </svg>
);

export const PlanMyNightChip: React.FC<PlanMyNightChipProps> = ({
    eventId,
}) => {
    const { trackInteraction } = useEventCardTrackingContext();

    const handleClick = (e: React.MouseEvent) => {
        trackInteraction?.(EventInteractions.Click);
        e.stopPropagation();
    };

    return (
        <a
            className={styles.chip}
            href={`${PLANS_PATH}?eventId=${eventId}`}
            onClick={handleClick}
        >
            <SignalAiIcon />
            {gettext('Make it a plan')}
        </a>
    );
};
